import { createSelector, createFeatureSelector, ActionReducerMap } from '@ngrx/store';
import * as fromData from './data.reducer';
import { ManagementModuleState } from '..';

const selectManagementModuleState = createFeatureSelector<ManagementModuleState>('management');

const selectDataState = createSelector(selectManagementModuleState, (state: ManagementModuleState) => state?.data);

export const selectDocuments = createSelector(selectDataState, fromData.getCurrentDocuments);

export const selectQueryParams = createSelector(selectDataState, fromData.getQueryParams);

export const selectDocumentForDelete = createSelector(selectDataState, fromData.getDocumentForDelete);

export const selectShowEditDocument = createSelector(selectDataState, fromData.getShowEditDocument);

export const selectIsWorking = createSelector(selectDataState, fromData.getIsWorking);

export const selectIsNewDocument = createSelector(selectDataState, fromData.getIsNewDocument);

export const selectSelectedDocument = createSelector(selectDataState, fromData.getSelectedDocument);

export const selectEditDocumentView = createSelector(selectDataState, fromData.getEditDocumentView);

export const selectSearchTerm = createSelector(selectDataState, fromData.getSearchTerm);
